import { categories } from '../data/priceData'

/**
 * Looks up a price from the shared Prices page data by category id and English item name,
 * so every surface shows the same amount.
 */
export function getPrice(categoryId: string, englishName: string): string {
  const item = categories
    .find((category) => category.id === categoryId)
    ?.items.find((entry) => entry.name.en === englishName)
  return item?.price ?? ''
}
